/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Compliance_Euai_LinkInputs */

const en_landing_compliance_euai_link = /** @type {(inputs: Landing_Compliance_Euai_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How Article 50 transparency works`)
};

const de_landing_compliance_euai_link = /** @type {(inputs: Landing_Compliance_Euai_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So funktioniert die Transparenz nach Artikel 50`)
};

const fr_landing_compliance_euai_link = /** @type {(inputs: Landing_Compliance_Euai_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprendre la transparence de l’article 50`)
};

const es_landing_compliance_euai_link = /** @type {(inputs: Landing_Compliance_Euai_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo funciona la transparencia del artículo 50`)
};

const it_landing_compliance_euai_link = /** @type {(inputs: Landing_Compliance_Euai_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come funziona la trasparenza dell’articolo 50`)
};

const nl_landing_compliance_euai_link = /** @type {(inputs: Landing_Compliance_Euai_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zo werkt transparantie volgens artikel 50`)
};

const pl_landing_compliance_euai_link = /** @type {(inputs: Landing_Compliance_Euai_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jak działa przejrzystość na podstawie art. 50`)
};

const fi_landing_compliance_euai_link = /** @type {(inputs: Landing_Compliance_Euai_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miten 50 artiklan läpinäkyvyys toimii`)
};

const da_landing_compliance_euai_link = /** @type {(inputs: Landing_Compliance_Euai_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sådan fungerer gennemsigtighed efter artikel 50`)
};

const sv_landing_compliance_euai_link = /** @type {(inputs: Landing_Compliance_Euai_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Så fungerar transparens enligt artikel 50`)
};

/**
* | output |
* | --- |
* | "How Article 50 transparency works" |
*
* @param {Landing_Compliance_Euai_LinkInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_compliance_euai_link = /** @type {((inputs?: Landing_Compliance_Euai_LinkInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Compliance_Euai_LinkInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_compliance_euai_link(inputs)
	if (locale === "fr") return fr_landing_compliance_euai_link(inputs)
	if (locale === "es") return es_landing_compliance_euai_link(inputs)
	if (locale === "it") return it_landing_compliance_euai_link(inputs)
	if (locale === "nl") return nl_landing_compliance_euai_link(inputs)
	if (locale === "pl") return pl_landing_compliance_euai_link(inputs)
	if (locale === "fi") return fi_landing_compliance_euai_link(inputs)
	if (locale === "da") return da_landing_compliance_euai_link(inputs)
	if (locale === "sv") return sv_landing_compliance_euai_link(inputs)
	return en_landing_compliance_euai_link(inputs)
});